import React from "react";
import { Middleware } from "redux";
import { addMiddleware, removeMiddleware } from "redux-dynamic-middlewares-2";
import { Event } from "@planzone/events";

type Subscriber = (event: Event) => void;

type Options = {
  localOnly?: boolean;
};

function useMessage(
  subscribe: Subscriber,
  options: Options = { localOnly: true },
) {
  React.useEffect(() => {
    const middleware: Middleware = (_) => (next) => (action) => {
      if (!options?.localOnly || !(action.data as any)?._sender) {
        subscribe(action);
      }

      return next(action);
    };

    addMiddleware(middleware);

    return () => removeMiddleware(middleware);
  }, [subscribe]);
}

export { useMessage };
